import { Redirect } from "expo-router";

/** Bare `/manager` → the Client dashboard. The Manager portal is retired. */
export default function ManagerIndexRedirect() {
  return <Redirect href="/client" />;
}
